// import { TEMPVERSON } from '../cache'

export default {
  initWebGo: routerHistory => {
    document.body.scrollTop = 0;
    //  这个方法，是让安卓调用的，他通过这个方法，告诉我在他写的头上面，用户做了哪些操作。
    if (!window.webGoUrl) {
      window.webGoUrl = function(urlType='list') {
        let props = routerHistory;
        if (!props) {
          return
        }
        let url = window.location.pathname;
        if (url.indexOf('#') !== -1) {
          url = url.substring(0, url.indexOf('#'))
        }
        let flag = true;
        while (flag) {
          if (url.lastIndexOf('/') !== 0) {
            url = url.substring(0, url.lastIndexOf('/'))
          } else {
            flag = false
          }
        }
        const strings = url.split('_');
        let targetUrl = '';
        let type = strings[strings.length - 1];
        if (strings.length === 1) {
          targetUrl = strings[0]
        } else if (strings.length === 2) {
          targetUrl = `${strings[0]}_${urlType}`
        } else if (strings.length === 3) {
          targetUrl = `${strings[0]}_${strings[1]}_${urlType}`
        }
        /* 安卓需要传给我下面的值，来让我知道我该显示什么页面。
         *  urlType = 'add' 表示点击 新增
         *  urlType = 'list' 表示点击 列表
         *  urlType = 'back' 表示点击 返回
         * */
        if (urlType === 'back') {
          props.history.go(-1);
          // if (type === 'add' || type === 'edit' || url === '/details') {
            // window.history.go(-1)
          //   props.history.push('/routine')
          // } else if (type === 'list') {
          //   props.history.push('/routine')
          // }
          // if (TEMPVERSON.android) {
          //   props.history.push('/routineandroid')
          //   window._czc.push(['_trackEvent', '返回常规记录二级页面'])
          // } else {
          //   props.history.push('/routine')
          //   window._czc.push(['_trackEvent', '返回常规记录二级页面'])
          // }
        } else if (urlType === 'add' || urlType === 'list') {
          props.history.push(targetUrl)
        }
      }
    }
  },
  sendToNative: function(obj) {
    if (typeof android === 'undefined') {
      window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.IOS &&
        window.webkit.messageHandlers.IOS.postMessage(JSON.stringify(obj))
    } else {
      // 告诉安卓，他要显示的头部,以及显示内容。
      window.android.testJs(JSON.stringify(obj))
    }
  },
  callNativeModal: function (modalType = 'createDialog') {
    if(typeof android === 'undefined'){
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.IOS &&
      window.webkit.messageHandlers.IOS.postMessage(JSON.stringify({
        type: modalType,//ios系统 'createDialog'  'backHome'
        url: '/setting'
      }))

    } else{
      // 安卓系统：'createDialog'：模态框  'backHome'：回到主页
      window.android && window.android.postMessage && window.android.postMessage(modalType)
    }
  },
  callNativePage: function (page) {
    console.log(JSON.stringify({
      type: page
    }));
    // H5调用原生的界面
    if(typeof android === 'undefined'){
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.IOS &&
      window.webkit.messageHandlers.IOS.postMessage(JSON.stringify({
        type: page
      }))

    } else{
      // 安卓系统
      window.android && window.android.postMessage && window.android.postMessage(page)
    }
  }
}
